/**
 * Giờ mở cửa của chi nhánh: đổi qua lại giữa dữ liệu máy chủ (danh sách khoảng) và form (theo thứ).
 *
 * Một ngày có thể có **nhiều khoảng** (tiệm nghỉ trưa: 08:00–12:00 và 13:00–20:00) — máy chủ nhận
 * tối đa 21 khoảng một tuần. Bản cũ chỉ đọc khoảng đầu của mỗi ngày, nên lưu lại là **mất ca
 * chiều** (xem gio-lam.test.ts). Hàm thuần, có test.
 */
export interface KhoangGio {
  mo: number
  dong: number
}

/** Thứ ISO 1..7 → các khoảng mở cửa trong ngày. Mảng rỗng = ngày nghỉ. */
export type TuanGio = Record<number, KhoangGio[]>

export interface GioLamMayChu {
  thu: number
  moMin: number
  dongMin: number
}

export const CAC_THU = [1, 2, 3, 4, 5, 6, 7] as const

export function gioLamSangTuan(gioLam: GioLamMayChu[]): TuanGio {
  const tuan: TuanGio = {}
  for (const t of CAC_THU) {
    tuan[t] = gioLam
      .filter((g) => g.thu === t)
      .map((g) => ({ mo: g.moMin, dong: g.dongMin }))
      .sort((a, b) => a.mo - b.mo)
  }
  return tuan
}

export function tuanSangGioLam(tuan: TuanGio): GioLamMayChu[] {
  return CAC_THU.flatMap((thu) =>
    [...(tuan[thu] ?? [])]
      .sort((a, b) => a.mo - b.mo)
      .map((k) => ({ thu, moMin: k.mo, dongMin: k.dong })),
  )
}
